import { Component, HostBinding, ChangeDetectionStrategy, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { EuiMenuItem } from '../../components/eui-menu/models/eui-menu-item.model';

@Component({
    selector: 'eui-sidebar-menu',
    templateUrl: './eui-sidebar-menu.component.html',
    styleUrls: ['./_styles/_index.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.None,
})
export class EuiSidebarMenuComponent {
    @HostBinding('class') string = 'eui-sidebar-menu';

    @Input() items: any[] = [];
    @Input() isCollapsed = false;
    @Input() hasFilter = false;
    @Input() hasIcons = false;
    @Input() hasTooltip = false;
    @Input() expandAllItems = false;
    @Input() style = '';
    @Input() fragmentId: string;    // Anchor to navigate to (see eui-menu)
    @Input() searchFilterLabel: string;
    @Input() expandMenuLabel: string;
    @Input() collapseMenuLabel: string;
    @Input() externalLinkLabel: string;

    @Output() onClicked: EventEmitter<any> = new EventEmitter();
    @Output() onItemClicked: EventEmitter<EuiMenuItem> = new EventEmitter();

    constructor() { }

    public onMenuItemClicked(item: EuiMenuItem) {
        this.onItemClicked.emit(item);
    }

    public onMenuClicked(event: any) {
        this.onClicked.emit(event);
    }

    public onMenuCollapsed(event: any) {
        this.isCollapsed = event;
    }
}
